import controller from './doctor-search.controller'
import template from './doctor-search.html'

const DoctorSearchComponent = {
	bindings: {
		carrierList: '<',
		planList: '<',
		doctorList: '<',
		doctorOrConditionList: '<',
		language: '<',
		onSearch: '&'
	},
	controller,
	template,
};

export default DoctorSearchComponent;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-search/doctor-search.component.js